import { InputType } from 'emma-common-ts/emma';

export const VALIDATOR_HELP_ERROR_MSG: { [k in InputType]?: string } = {
  urlparam: $localize`Los carácteres permitidos son A-Z, 0-9, a-z, _ , -`,
};
